module.exports = __webpack_public_path__ + "static/media/visualizing_error2.25251566.JPG";